import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import Typography from "@mui/material/Typography";
import { FormControl, IconButton } from "@mui/material";
import { TableContainer } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import { getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI } from "../../../utils/datetime.utils";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';

const localeTheme = createTheme(
    {

    },
    localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);
function TabContainer({ children, dir, classes }) {
    return (
        <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
            {children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};
function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    if (array && array.length <= 0) {
        return [];
    }
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
    createSortHandler = (property, field) => event => {
        this.props.onRequestSort(event, property, field);
    };

    render() {
        const {
            order,
            orderBy,
            sortId,
            t
        } = this.props;
        const rows = [
            { id: "order_id", numeric: false, disablePadding: false, label: t("Report.OrderStaging.OrderID"), padding: '10px', field: 'order_id' },
            { id: "order_timestamp", numeric: false, disablePadding: false, label: t("Report.OrderStaging.OrderTimestamp"), padding: '10px', field: 'order_timestamp' },
            { id: "store_ncpdp", numeric: false, disablePadding: false, label: t("Report.OrderStaging.StoreNCPDP"), padding: '10px', field: 'store_ncpdp' },
            { id: "patient_id", numeric: false, disablePadding: false, label: t("Report.OrderStaging.PatientID"), padding: '10px', field: 'patient_id' },
            { id: "first_name", numeric: false, disablePadding: false, label: t("Report.OrderStaging.FirstName"), padding: '10px', field: 'first_name' },
            { id: "last_name", numeric: false, disablePadding: false, label: t('Report.OrderStaging.LastName'), padding: '10px', field: 'last_name' },
            { id: "gender", numeric: false, disablePadding: false, label: t("Report.OrderStaging.Gender"), padding: '10px', field: 'gender' },
            { id: "dob", numeric: false, disablePadding: false, label: t("Report.OrderStaging.DOB"), padding: '10px', field: 'dob' },
            { id: "email", numeric: false, disablePadding: false, label: t("Report.OrderStaging.Email"), padding: '10px', field: 'email' },
            { id: "sms_phone", numeric: false, disablePadding: false, label: t("Report.OrderStaging.Phone"), padding: '10px', field: 'sms_phone' },
            { id: "prescription_number", numeric: false, disablePadding: false, label: t("Report.OrderStaging.PrescriptionNumber"), padding: '10px', field: 'prescription_number' },
            { id: "drug_name", numeric: false, disablePadding: false, label: t("Report.OrderStaging.DrugName"), padding: '10px', field: 'drug_name' },
            { id: "ndc", numeric: false, disablePadding: false, label: t("Report.OrderStaging.NDCCode"), padding: '10px', field: 'ndc' },
            { id: "prescription_txn_id", numeric: false, disablePadding: false, label: t("Report.OrderStaging.TransactionID"), padding: '10px', field: 'prescription_txn_id' },
            { id: "fillid", numeric: false, disablePadding: false, label: t("Report.OrderStaging.FillID"), padding: '10px', field: 'fillid' },
            { id: "prescription_id", numeric: false, disablePadding: false, label: t("Report.OrderStaging.PrescriptionID"), padding: '10px', field: 'prescription_id' },
            { id: "amount_due", numeric: false, disablePadding: false, label: t("Report.OrderStaging.AmountDue"), padding: '10px', field: 'amount_due' },
            { id: "dispensed_qty", numeric: false, disablePadding: false, label: t("Report.OrderStaging.DispensedQty"), padding: '10px', field: 'dispensed_qty' },
            { id: "expiry_date", numeric: false, disablePadding: false, label: t("Report.OrderStaging.ExpiryDate"), padding: '10px', field: 'expiry_date' },
            { id: "order_reciept_date", numeric: false, disablePadding: false, label: t("Report.OrderStaging.OrderReceiptDate"), padding: '10px', field: 'order_reciept_date' },
            { id: "client_identifier", numeric: false, disablePadding: false, label: t("Report.OrderStaging.ClientIdentifier"), padding: '10px', field: 'client_identifier' }
        ];

        return (
            <TableHead>
                <TableRow>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
                            >
                                {["gender", "email", "sms_phone", "ndc", "amount_due", "dispensed_qty"].includes(row.id)
                                    ? (
                                        <TableSortLabel style={{ cursor: "text" }}>{row.label}</TableSortLabel>
                                    ) : (
                                        <Tooltip
                                            title={t("Global.Label.Filter.Sort")}
                                            placement={row.numeric ? "bottom-end" : "bottom-start"}
                                            enterDelay={300}
                                        >
                                            <TableSortLabel
                                                active={orderBy === row.field && sortId === row.id}
                                                direction={order}
                                                onClick={this.createSortHandler(row.id, row.field)}
                                            >
                                                {row.label}
                                            </TableSortLabel>
                                        </Tooltip>
                                    )
                                }
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = theme => ({
    root: {
        width: "100%",
    },
    table: {
        minWidth: 1020
    },
    tableWrapper: {
        overflowX: "auto"
    },
    dob: {
        paddingTop: '25px',
    },
    headerdiv: {
        paddingLeft: '15%',
        paddingTop: '10'
    },
    padding10px: {
        padding: '10px'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 390,
    },
    logoWrapper:
    {
        position: 'absolute',
        width: '89%',
        height: '70%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.5)',
        zIndex: '7869'
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
    hidden: {
        display: 'none'
    },
    rowheight: {
        height: '35px'
    }
});

let OrderViewFilterObj = {
    searchtext: '',
    fromdate: '',
    todate: '',
    pageNo: 0,
    pageSize: 10,
    sortOrder: 'desc',
    sortColumn: 'order_timestamp',
    tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            order: "desc",
            dob: '',
            orderBy: "order_timestamp",
            page: 0,
            rowsPerPage: 10,
            searchtext: '',
            store_id: [],
            box_id: [],
            fromdate: null,
            todate: null,
            dateRangePreset: 'last7days',
            isOpen: false,
            stores: [],
            boxes: [],
            boxvalues: [],
            accountValues: [],
            nstores: [],
            nboxes: [],
            chipstores: [],
            chipboxes: [],
            loader: false,
            selectedObject: null,
            isDataEmpty: true,
            selectedTab: 0,
            tempThresholds: [],
            totalRecords: 0,
            locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale
        };
        this.debouceTimeout = null;
    }

    componentDidMount() {
        this.setState({ loader: true });
        // Set default date range (T-30 days to today)
        const defaultDates = getDefaultDateRange();
        this.setState({ 
            fromdate: defaultDates.fromDate,
            todate: defaultDates.toDate,
            dateRangePreset: 'last7days'
        });

        OrderViewFilterObj = {
            searchtext: '',
            fromdate: formatFromDateForAPI(defaultDates.fromDate),
            todate: formatToDateForAPI(defaultDates.toDate),
            pageNo: 0,
            pageSize: 10,
            sortOrder: 'desc',
            sortColumn: 'order_timestamp',
            tableName: ''
        }
        this.fetchSuggestions();
        this.BindGrid();
    }

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        let zone;
        zone = sessionStorage.getItem('timeZone');
        const date = moment(new Date(requestDate));
        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }
        return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
    }


    gettingOnSortTableName = (field) => {
        let tablename = '';
        if (['order_id', 'order_timestamp', 'store_ncpdp', 'patient_id', 'first_name', 'last_name', 'dob',
            'prescription_number', 'drug_name', 'prescription_txn_id', 'fillid',
            'prescription_id', 'expiry_date', 'order_reciept_date', 'client_identifier'].includes(field)) {
            tablename = 'order_staging';
        }
        return tablename;
    }

    handleRequestSort = (event, property, field) => {
        const orderBy = property;
        let order = "desc";
        if (this.state.order === "desc") {
            order = "asc";
        }
        this.setState({ order, orderBy, sortId: property });
        OrderViewFilterObj.sortOrder = order;
        OrderViewFilterObj.sortColumn = field;
        OrderViewFilterObj.tableName = this.gettingOnSortTableName(orderBy);
        const { data } = this.state;
        if (data && data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangePage = (event, page) => {
        event && event.preventDefault();
        const { data } = this.state;
        OrderViewFilterObj.pageNo = page;
        if (data && data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangeRowsPerPage = event => {
        const { data } = this.state;
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.pageSize = event.target.value;
        if (data && data.length > 0) {
            this.BindGrid();
        }
    };

    //Search Text Box change event
    onSearchChange = (event) => {
        this.debouceTimeout && clearInterval(this.debouceTimeout);
        const searchString = event.target.value;
        this.setState({ searchtext: searchString && searchString });
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        OrderViewFilterObj.searchtext = searchString;
        this.debouceTimeout = setTimeout(() => {
            this.BindGrid();
        }, 1000)
    }

    onFromDateSelect = date => {
        const dateObj = date ? moment(date) : null;
        this.setState({ fromdate: dateObj, dateRangePreset: '' });
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        OrderViewFilterObj.fromdate = formatFromDateForAPI(dateObj);
        this.BindGrid();
    };

    onToDateSelect = date => {
        const dateObj = date ? moment(date) : null;
        this.setState({ todate: dateObj, dateRangePreset: '' });
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        OrderViewFilterObj.todate = formatToDateForAPI(dateObj);
        this.BindGrid();
    };

    handleBlurfrom = (value, date) => {
        const dateObj = date ? moment(date) : null;
        this.setState({
            fromdate: dateObj,
            dateRangePreset: ''
        });
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        OrderViewFilterObj.fromdate = formatFromDateForAPI(dateObj);
        this.BindGrid();
    }

    handleBlurtodate = (value, date) => {
        const dateObj = date ? moment(date) : null;
        this.setState({
            todate: dateObj,
            dateRangePreset: ''
        });
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        OrderViewFilterObj.todate = formatToDateForAPI(dateObj);
        this.BindGrid();
    }
    
    handleDateRangePresetChange = (event) => {
        const preset = event.target.value;
        if (!preset) return;
        
        const dateRange = getDateRangeByPreset(preset);
        this.setState({
            fromdate: dateRange.fromDate,
            todate: dateRange.toDate,
            dateRangePreset: preset
        });
        
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        OrderViewFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
        OrderViewFilterObj.todate = formatToDateForAPI(dateRange.toDate);
        this.BindGrid();
    };

    BindGrid() {
        this.setState({ loader: true, data: null });
        fetch(process.env.REACT_APP_BASEURL + 'all/orders', {
            method: 'post',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(OrderViewFilterObj)
        }).then(response => {
            try {
                return response.json();
            } catch (error) {
                return null;
            }
        }).then(uData => {
            if (uData && uData.results && uData.results.length > 0) {
                this.setState({ data: uData && uData.results, totalRecords: uData && uData.total });
                setTimeout(() => {
                    this.setState({ loader: uData && uData.total && false, isDataEmpty: false })
                }, 5000)
            }
            else {
                this.setState({ data: null, loader: false, isDataEmpty: true });
            }
        });
    }

    fetchSuggestions = async () => {
        try {
          const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
            method: "GET",
            withCredentials: true,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                  .jwtToken,
              "Content-Type": "application/json",
            },
          }
          );
          result
            .then((result) => {
              result.json().then((resLocation) => {
                this.setState({ groups: resLocation && resLocation.data })
              })
            })
        } catch (error) {
          console.error("Error fetching groups:", error);
        }
      };

    render() {
        const { classes, t } = this.props;
        const { data, totalRecords, locale } = this.state;
        return (
            <Paper id="react-no-print" className={classes.root}>
                {
                    this.state.loader ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> :
                        null
                }
                <div id="react-no-print">
                    <Table className={classes.table} aria-labelledby="tableTitle">
                        <TableBody>
                            <TableRow >
                                <TableCell style={{ width: "15%", borderBottom: "none", paddingTop: "13px" }}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel variant="standard">{t("Global.Label.DropDown.DateRange") || "Date Range"}</InputLabel>
                                        <Select
                                            value={this.state.dateRangePreset}
                                            onChange={this.handleDateRangePresetChange}
                                            variant="standard"
                                            label={t("Global.Label.DropDown.DateRange") || "Date Range"}
                                        >
                                            <MenuItem value="today">{t("Global.Label.DropDown.Today") || "Today"}</MenuItem>
                                            <MenuItem value="last7days">{t("Global.Label.DropDown.Last7Days") || "Last 7 days"}</MenuItem>
                                            <MenuItem value="last15days">{t("Global.Label.DropDown.Last15Days") || "Last 15 days"}</MenuItem>
                                            <MenuItem value="last30days">{t("Global.Label.DropDown.Last30Days") || "Last 30 days"}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </TableCell>
                                <TableCell style={{ width: "17%", borderBottom: "none", paddingTop: "13px" }}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                            <DesktopDatePicker
                                                disableFuture
                                                keyboard
                                                value={this.state.fromdate}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        label={t("Report.OrderStaging.FromDate")}
                                                        variant="standard"
                                                        allowKeyboardControl={true}
                                                        onBlur={this.handleBlurfrom}
                                                    />
                                                }
                                                onChange={this.onFromDateSelect}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </TableCell>
                                <TableCell style={{ width: "17%", borderBottom: "none", paddingTop: "13px" }}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                            <DesktopDatePicker
                                                disableFuture
                                                keyboard
                                                value={this.state.todate}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        label={t("Report.OrderStaging.ToDate")}
                                                        variant="standard"
                                                        allowKeyboardControl={true}
                                                        onBlur={this.handleBlurtodate}
                                                    />
                                                }
                                                onChange={this.onToDateSelect}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </TableCell>
                                <TableCell style={{ width: "30%", borderBottom: "none" }}>
                                    <TextField id="idsearchtxt"
                                        defaultValue=""
                                        value={this.state.searchtxt}
                                        label={t("Report.OrderStaging.Search")}
                                        onChange={this.onSearchChange}
                                        className={classes.formControl} fullWidth
                                        inputProps={{
                                            autocomplete: 'new-password',
                                            form: {
                                                autocomplete: 'off',
                                            },
                                        }}
                                        variant="standard"
                                    />
                                </TableCell>
                                <TableCell style={{ width: "25%", borderBottom: "none", textAlign: "right" }}>
                                    <Tooltip key="single-edit" title={t("Report.OrderStaging.ExportCSVTooltip")}>
                                        <IconButton
                                            style={{ marginRight: '0' }}
                                            aria-label="ExportCSV"
                                        >
                                            <img alt="download" onClick={() => { this.exportCSV() }} src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
                <Divider style={{ marginTop: '10px', height: '5px' }} />
                <div className={classes.tableWrapper}>
                    <TableContainer>
                        <Table className={classes.table} aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                order={OrderViewFilterObj.sortOrder}
                                orderBy={OrderViewFilterObj.sortColumn}
                                sortId={this.state.sortId}
                                onRequestSort={this.handleRequestSort}
                            />
                            <TableBody>
                                {!data ?
                                    (
                                        <TableRow>
                                            <TableCell colSpan={21} style={{ textAlign: "center", padding: '10px 0px' }}>
                                                {this.state.isDataEmpty && t("Report.OrderStaging.NoDataFound")}
                                            </TableCell>
                                        </TableRow>
                                    ) : data.length && data.length > 0 &&
                                    stableSort(data, getSorting(OrderViewFilterObj.sortOrder, OrderViewFilterObj.sortColumn))
                                        .map(n => {
                                            return (
                                                <TableRow>
                                                    <TableCell className={classes.padding10px} >{n.order_id}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.order_timestamp ? this.convertToTimeZone(n && n.order_timestamp) : ''}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.store_ncpdp}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.patient_id}</TableCell>
                                                    <TableCell className={classes.padding10px} >{n.first_name}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.last_name}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.gender}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.dob}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.email}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.sms_phone}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.prescription_number}</TableCell>
                                                    <TableCell className={classes.padding10px} >{n.drug_name}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.ndc}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.prescription_txn_id}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.fillid}</TableCell>
                                                    <TableCell className={classes.padding10px} >{n.prescription_id}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.amount_due ? '$' + parseFloat(n.amount_due).toFixed(2) : '$0.00'}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.dispensed_qty}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.expiry_date ? this.convertToTimeZone(n && n.expiry_date) : ''}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.order_reciept_date ? this.convertToTimeZone(n && n.order_reciept_date) : ''}</TableCell>
                                                    <TableCell className={classes.padding10px}>{n.client_identifier}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <ThemeProvider theme={localeTheme}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalRecords || 0}
                        rowsPerPage={OrderViewFilterObj.pageSize}
                        page={OrderViewFilterObj.pageNo}
                        backIconButtonProps={{
                            "aria-label": "Previous Page"
                        }}
                        nextIconButtonProps={{
                            "aria-label": "Next Page"
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </ThemeProvider>
            </Paper>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/orders-view/index.js